import { useEffect, useState } from 'react';
import useAuth from '../utils/auth';
import ViewerPanel from '../components/settings/viewerPanel';
import AdminDashboard from '../components/settings/orgAdminPanel';
import GetOrganisationUsers from '../services/adapters/organisationUsers';
import { DisplayOrganisationUser } from '../types/core.type';
import Role from '../types/enums';

export default function Settings() {
  const [organisationUsers, setOrganisationUsers] = useState<Array<DisplayOrganisationUser>>([]);
  const [hasOrganisationUsersAccess, setHasOrganisationUsersAccess] = useState(false);

  const authUser = useAuth();

  useEffect(() => {
    const getUserData = async () => {
      if (authUser.role !== Role.Viewer) {
        try {
          const organisationUserInstance = new GetOrganisationUsers();
          const organisationUsersResponse = await organisationUserInstance.adaptResponse();
          const responseWithoutCurrentUser = organisationUsersResponse.filter((userResponse: DisplayOrganisationUser) => userResponse.email !== authUser.email);
          setOrganisationUsers(responseWithoutCurrentUser);
          setHasOrganisationUsersAccess(true);
        } catch (error) {
          if (error instanceof Error) {
            throw new Error('Failed to fetch organisation users');
          }
        }
      }
    };

    void getUserData();
  }, [authUser.email, authUser.role]);

  const viewerPanelUser = {
    firstName: authUser.firstName,
    lastName: authUser.lastName,
    email: authUser.email,
    organisationDisplayName: authUser.organisationDisplayName,
    role: authUser.role,
  };

  return (
    <div className="flex flex-col w-full p-4 overflow-auto">
      <ViewerPanel user={viewerPanelUser} />
      {hasOrganisationUsersAccess && <AdminDashboard tableData={organisationUsers} userRole={authUser.role} />}
    </div>

  );
}
